import React, { ChangeEvent, useEffect, useState } from "react";
import { EditableSpeedProps } from "./types";

const EditableSpeed = ({
  editable,
  text,
  editPlayerSpeed,
  playerId,
  isMaxS,
  reportValidity,
}: EditableSpeedProps) => {

  const [value, setValue] = useState(text);

  // Validation: just numbers, max 2 decimals, 5-24
  const validate = (val: string) => {
    if (val === "") return true; // empty allowed just on UI

    const regex = /^\d*\.?\d{0,2}$/;
    if (!regex.test(val)) return false;

    const num = parseFloat(val);
    return !isNaN(num) && num >= 5 && num <= 24;
  };
 const handleSpeedChange = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (!regex.test(val)) return;

    setValue(val);

    const isValid = validate(val);
    const isEmpty = val === "";

    reportValidity(playerId, isMaxS ? "maxS" : "max", isValid && !isEmpty, isEmpty);

    // Update store/global state
    editPlayerSpeed(playerId, isMaxS ? "maxS" : "max", val);
  };
    useEffect(() => {
    const isValid = validate(value.toString());
    const isEmpty = value === "";
    reportValidity(playerId, isMaxS ? "maxS" : "max", isValid && !isEmpty, isEmpty);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fieldIsValid = validate(value.toString());
const showRedBorder = value !== "" && !fieldIsValid;
  return (
    <>
      {!editable ? (
        text
      ) : (
        <>
          <input
            type="text"
            maxLength={5}
            style={showRedBorder? {borderColor: 'red', width: '80px'}:{ width: "80px" }}
            value={text}
            onChange={(event) => handleSpeedChange(event)}
          />
        </>
      )}
    </>
  );
};

export default EditableSpeed;
